const COMMON_ERROR_FORM_TEXT = "Make sure the information entered is correct.";

export const SET_ERROR = "SET_ERROR";
export const SET_LOADING = "SET_LOADING";
export const SET_SUBHEADER_ITEMS = "SET_SUBHEADER_ITEMS";
export const SET_HEADER_BAR = "SET_HEADER_BAR";

function setError(error = COMMON_ERROR_FORM_TEXT) {
  return {
    type: SET_ERROR,
    error
  };
}

export function setLoading(loading) {
  return {
    type: SET_LOADING,
    loading
  };
}

export function setSubHeader(subHeader) {
  return {
    type: SET_SUBHEADER_ITEMS,
    subHeader
  };
}

export function setHeaderBar(headerBar) {
  return {
    type: SET_HEADER_BAR,
    headerBar
  };
}

export function showError(errorText) {
  return dispatch => {
    dispatch(setError(errorText));

    /* Add any extra functionality here */
  };
}



// WEBPACK FOOTER //
// ./src/actions/common.actions.js